<template>
  <div class="full_list">
    <div class="query_wapper">
      <div class="query_item">
        <el-button
          :loading="btnLoading"
          style="width:90px;padding:12px 0;text-align:center"
          type="primary"
          @click="batchPass"
        >批量通过</el-button>
      </div>
      <div class="query_item">
        <el-button type="warning" style="width:90px" @click="print">打印</el-button>
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="success" @click="exportExcel">导出</el-button>
      </div>
      <div class="query_item">
        <el-select
          @change="handleSearch"
          :popper-append-to-body="false"
          placeholder="按学校名称查看"
          v-model="query.schoolId"
          style="width:200px"
          clearable
        >
          <el-option
            v-for="(item,index) in schoolList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item" v-if="userInfo.type !== 3">
        <el-select
          @change="handleSearch"
          style="width:180px"
          :popper-append-to-body="false"
          placeholder="按注册项目查看"
          clearable
          v-model="query.project"
        >
          <el-option
            v-for="(item,index) in projectList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          @change="handleSearch"
          style="width:180px"
          :popper-append-to-body="false"
          placeholder="按性别查看"
          clearable
          v-model="query.gender"
        >
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="0"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          @change="handleSearch"
          style="width:180px"
          placeholder="按等级查看"
          :popper-append-to-body="false"
          clearable
          v-model="query.refereeRank"
        >
          <el-option value="国际级" label="国际级"></el-option>
          <el-option value="国家级" label="国家级"></el-option>
          <el-option value="荣誉级" label="荣誉级"></el-option>
          <el-option value="一级" label="一级"></el-option>
          <el-option value="二级" label="二级"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:290px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item" style="margin-right:0" v-if="userInfo.type == 1">
        <el-button style="width:90px" type="danger" @click="deletes">删除</el-button>
      </div>
    </div>
    <printTable ref="print_table" :printColumns="printColumns" :printTableData="printTableData"></printTable>
    <el-table
      ref="table"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      border
      style="width:100%;margin-top:20px"
      :data="tableData"
    >
      <el-table-column type="selection" :reserve-selection="true" align="center" width="40"></el-table-column>
      <el-table-column type="index" align="center" label="序号" width="55"></el-table-column>
      <el-table-column label="学校名称" align="center" prop="schoolName" width="160"></el-table-column>
      <el-table-column prop="name" align="center" label="姓名" width="160"></el-table-column>
      <el-table-column prop="gender" align="center" label="性别" width="60">
        <template slot-scope="{row}">
          <span>{{!row.gender?'女':'男'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="民族" width="90" prop="nation"></el-table-column>
      <el-table-column align="center" label="出生年月" width="100" prop="birthdayText"></el-table-column>
      <el-table-column align="center" label="身份证" width="160" prop="idCard"></el-table-column>
      <el-table-column align="center" label="职称" width="80" prop="professionalRanks"></el-table-column>
      <el-table-column align="center" label="最后学历" width="80">
        <template slot-scope="{row}">
          <span>{{row.education === 1?'大专':row.education === 2?'本科':row.education === 3?'研究生':'其他'}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="注册项目" width="80" prop="projectNewText"></el-table-column>
      <el-table-column label="裁判等级" align="center" width="80" prop="refereeRank"></el-table-column>
      <el-table-column label="批准时间" align="center" width="100" prop="passDate">
        <template slot-scope="{row}">
          <span>{{formatTime(row.passDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" align="center" label="联系电话" width="100"></el-table-column>
      <el-table-column prop="state" align="center" label="状态" width="95">
        <template slot-scope="scope">
          <span
            :style="{color:screenStatus(scope.row.state).color}"
          >{{screenStatus(scope.row.state).label}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="105">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="lookRegistration(row.id,'watch')">查看</el-button>
          <el-button type="text" size="small" @click="operation(row.id,'pass')">通过</el-button>
          <el-button type="text" size="small" @click="openRejectModal(row.id)">驳回</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:40px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <el-dialog
      :lock-scroll="false"
      :append-to-body="true"
      center
      @close="closeDialog"
      :close-on-click-modal="false"
      top="50px"
      :visible.sync="centerDialogVisible"
      title="查看注册信息"
      width="1400px"
    >
      <judgeUpdateRegistrationPage
        @clearUpdate="clearUpdate"
        :updateObj="updateObj"
        @examineSubmit="examineSubmit"
      ></judgeUpdateRegistrationPage>
    </el-dialog>
    <el-dialog
      width="700px"
      title="驳回理由"
      :visible.sync="rejectVisible"
      :lock-scroll="false"
      :append-to-body="true"
      center
      @close="closeRejectDialog"
      :close-on-click-modal="false"
    >
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="reason"
        resize="none"
        height="450px"
        maxlength="200"
        show-word-limit
        :autosize="{ minRows: 8, maxRows: 15}"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          :loading="submitLoading"
          style="width:90px;margin-right:40px"
          type="primary"
          @click="handleSubmit"
        >确 定</el-button>
        <el-button style="width:90px;" @click="handleCancel">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      center
      :close-on-click-modal="false"
      title="删除"
      width="600px"
      :visible.sync="deleteModal"
    >
      <p style="font-size:18px;text-align:center;padding:20px">删除之后数据将不可恢复，是否继续？</p>
      <span slot="footer" class="dialog-footer">
        <el-button style="width:90px;margin-right:40px" type="primary" @click="handleDelete">确 定</el-button>
        <el-button style="width:90px;" @click="deleteModal = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { refereeList, societyAuditReferee, deleteJudge } from "@/api/judge.js";
import printTable from "@/components/print-table";
import judgeUpdateRegistrationPage from "../judge/component/update-registration-page";
import { getSchool } from "@/api/athletes.js";
import registerData from "@/assets/json/register.json";
import {
  table,
  page,
  message,
  btn,
  formatPrintTableData,
  dialog
} from "@/common/js/mixins";
import { getSession } from "@/utils/storage";
import { baseUrl } from "@/utils/config.js";
import { method } from "@/utils/utils";
export default {
  mixins: [table, page, message, btn, formatPrintTableData, dialog],
  components: {
    printTable,
    judgeUpdateRegistrationPage
  },
  data() {
    return {
      schoolList: [],
      reason: "",
      submitLoading: false,
      query: {
        keyword: "",
        gender: "",
        refereeRank: "",
        schoolId: ""
      },
      updateObj: {
        type: "",
        id: ""
      },
      userInfo: JSON.parse(getSession("userInfo")) || null,
      centerDialogVisible: false,
      rejectVisible: false,
      rejectId: "",
      type: null,
      // 表格多选数据
      multipleList: [],
      stateList: [
        {
          label: "草稿",
          value: 0,
          color: "rgb(64, 142, 232)"
        },
        {
          label: "学校待审核",
          value: 1,
          color: "rgb(64, 142, 232)"
        },
        { label: "学校未通过", value: 2, color: "rgb(252, 91, 91)" },
        { label: "分会待审核", value: 3, color: "rgb(64, 142, 232)" },
        { label: "分会未通过", value: 4, color: "rgb(252, 91, 91)" },
        { label: "分会通过", value: 5, color: "rgb(51, 204, 154)" }
      ]
    };
  },
  computed: {
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    },
    projectList() {
      return [
        ...registerData.sportsProjectList,
        ...registerData.sunshineProject
      ];
    },
    // 职称筛选
    getPositional() {
      return data => {
        let str = "";
        switch (data) {
          case 1: {
            str = "初级职称";
            break;
          }
          case 2: {
            str = "中级职称";
            break;
          }
          case 3: {
            str = "副教授（高级教练）";
            break;
          }
          case 4: {
            str = "教授（国家级教练）";
            break;
          }
        }
        return str;
      };
    },
    // 筛选状态
    screenStatus() {
      return data => {
        let status = {};
        this.stateList.filter(item => {
          if (data === item.value) status = item;
        });
        return status;
      };
    },
    // 筛选注册项目
    registProject() {
      return data => {
        let label = "";
        this.projectList.filter(item => {
          if (item.value === data) label = item.label;
        });
        return label;
      };
    },
    // 表格打印表头
    printColumns() {
      let column = [
        {
          title: "序号",
          key: "index",
          width: 55
        },
        {
          title: "学校名称",
          key: "schoolName"
        },
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "性别",
          key: "genderText",
          width: 55
        },
        {
          title: "民族",
          key: "nation"
        },
        {
          title: "出生年月",
          key: "birthdayText"
        },
        {
          title: "身份证",
          key: "idCard"
        },
        {
          title: "职称",
          key: "professionalRanks"
        },
        {
          title: "最后学历",
          key: "educationText"
        },
        {
          title: "注册项目",
          key: "projectNewText"
        },
        {
          title: "裁判等级",
          key: "refereeRank"
        },
        {
          title: "批准时间",
          key: "passDateText"
        },
        {
          title: "联系电话",
          key: "phone",
          width: 112
        },
        {
          title: "状态",
          key: "state"
        }
      ];
      return column;
    }
  },
  methods: {
    // 获取学校名称
    getSchoolList() {
      getSchool({})
        .then(res => {
          this.schoolList = res;
        })
        .catch(err => {});
    },
    // 打印
    async print() {
      let { gender, schoolId, refereeRank } = this.query;
      let { list } = await refereeList({
        ...this.query,
        gender: !gender && gender !== 0 ? null : gender,
        schoolId: !schoolId ? null : schoolId,
        refereeRank: !refereeRank ? null : refereeRank,
        state: 3,
        pageNo: 1,
        pageSize: 9999
      });
      // 调用公共方法打印（方法在mixins.js)
      this.getPrintData(list);
    },
    // 打开删除弹窗
    deletes() {
      if (this.multipleList.length == 0)
        return this.openWarn("请至少选择一条数据进行操作！");
      this.openDeleteDialog();
    },
    // 删除
    handleDelete() {
      let ids = this.multipleList
        .map(item => {
          return item.id;
        })
        .join(",");
      let currentPage =
        this.tableData.length === this.multipleList.length
          ? this.pageNo === 1
            ? this.pageNo
            : this.pageNo - 1
          : this.pageNo;
      deleteJudge({
        ids
      })
        .then(res => {
          this.openSuccess("删除成功！");
          this.closeDeleteDialog();
          this.getList(currentPage);
          this.$refs.table.clearSelection();
        })
        .catch(err => {});
    },
    // 驳回提交
    handleSubmit() {
      this.operation(this.rejectId, "reject");
    },
    // 驳回关闭
    handleCancel() {
      this.rejectVisible = false;
    },
    // 打开驳回弹窗
    openRejectModal(id) {
      this.rejectVisible = true;
      this.rejectId = id;
    },
    // 关闭驳回弹窗
    closeRejectDialog() {
      this.reason = "";
    },
    // 关闭弹窗
    closeDialog() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
    },
    // 查看/编辑页面返回
    clearUpdate() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
      this.centerDialogVisible = false;
    },
    // 审核提交成功
    examineSubmit() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
      this.centerDialogVisible = false;
      this.getList();
    },
    // 查看注册信息
    lookRegistration(id, type) {
      Object.assign(this.updateObj, {
        id,
        type
      });
      this.centerDialogVisible = true;
    },
    // 导出
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          if (this.query[k])
            params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      let type = JSON.parse(getSession("userInfo")).type;
      if (type === 1 || type === 5) {
        params.push("pageNo=" + this.pageNo);
        params.push("pageSize=" + this.pageSize);
      }
      let url =
        baseUrl +
        (type === 1 || type === 5
          ? "/referee/downloadAllList?"
          : "/referee/downloadList?");

      window.location.href = url + params.join("&");
    },
    // 通过/驳回
    operation(id, type) {
      societyAuditReferee({
        ids: id,
        reason: this.reason,
        state: type === "pass" ? 5 : 4
      })
        .then(res => {
          this.rejectVisible = false;
          this.openSuccess("操作成功!");
          this.getList();
        })
        .catch(err => {
          this.rejectVisible = false;
        });
    },
    // 批量通过
    batchPass() {
      if (this.multipleList.length == 0)
        return this.openWarn("请至少选择一条数据进行操作！");
      this.openBtn();
      let ids = this.multipleList
        .map(item => {
          return item.id;
        })
        .join(",");
      societyAuditReferee({
        ids,
        reason: this.reason,
        state: 5
      })
        .then(res => {
          this.openSuccess("操作成功!");
          this.getList();
          this.closeBtn();
        })
        .catch(err => {
          this.closeBtn();
        });
    },
    // 表格多选数据
    handleSelectionChange(val) {
      this.multipleList = val;
    },
    // 根据当前为运动员或教练员请求接口
    getList(currentPage = this.pageNo) {
      let { gender, schoolId, refereeRank } = this.query;
      refereeList({
        ...this.query,
        gender: !gender && gender !== 0 ? null : gender,
        schoolId: !schoolId ? null : schoolId,
        refereeRank: !refereeRank ? null : refereeRank,
        state: 3,
        pageNo: currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
        })
        .catch(err => {});
    },
    // 指定一个key标识这一行的数据
    getRowKey(row) {
      return row.id;
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    }
  },
  mounted() {
    let { currentRole } = JSON.parse(getSession("userInfo")) || "";
    this.type = currentRole;
    this.getSchoolList();
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.full_list {
  /deep/ .el-table .cell {
    padding: 0 !important;
  }
}
</style>